var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSugarDating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.082 21.4498C29.749 16.8501 22.6587 16.85 18.3256 21.4498C6.55349 33.9464 29.2166 55.7861 37 58C44.7834 55.7861 67.4465 33.9464 55.6744 21.4498C51.3414 16.85 44.251 16.8501 39.918 21.4498C38.1812 23.2935 35.6383 23.1018 34.082 21.4498ZM24.2088 41.0825C30.3433 44.9576 31.1189 34.3197 37 39.225C42.8811 34.3197 43.6566 44.9576 49.7912 41.0825C49.7912 41.0825 48.4282 47.1644 43.3957 45.6664L43.5792 46.685C43.5792 46.685 38.0572 47.6014 37.0001 43.2409C35.943 47.6014 30.421 46.685 30.421 46.685L30.6044 45.6664C25.5718 47.1644 24.2088 41.0825 24.2088 41.0825Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugarDating);
export default __webpack_public_path__ + "static/media/sugar_dating.db7f4018def8b5e5e9e9499cbc61b9e6.svg";
export { ForwardRef as ReactComponent };